import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const OfficeBagIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };
  return (
    <svg
      width={finalSize.width || "24"}
      height={finalSize.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4904 22.75H7.50042C5.78042 22.75 4.49043 22.29 3.69043 21.38C2.89043 20.47 2.58042 19.15 2.79042 17.44L2.79043 9.94C3.05043 7.73 4.51043 5.75 8.41043 5.75H15.6104C19.5004 5.75 20.9604 7.73 21.2304 9.94V17.44C21.4304 19.15 21.1304 20.48 20.3304 21.38C19.5004 22.29 18.2204 22.75 16.4904 22.75ZM8.40042 7.25C5.52042 7.25 4.48043 8.38999 4.27043 10.11V17.61C4.12043 18.88 4.30042 19.81 4.81042 20.38C5.32042 20.95 6.22042 21.24 7.50042 21.24H16.4904C17.7704 21.24 18.6704 20.95 19.1804 20.38C19.6904 19.81 19.8704 18.88 19.7204 17.61V10.11C19.5104 8.37999 18.4804 7.25 15.5904 7.25H8.40042Z"
        fill="currentColor"
      />
      <path
        d="M16 8.75C15.59 8.75 15.25 8.41 15.25 8V4.5C15.25 3.42 14.58 2.75 13.5 2.75H10.5C9.42 2.75 8.75 3.42 8.75 4.5V8C8.75 8.41 8.41 8.75 8 8.75C7.59 8.75 7.25 8.41 7.25 8V4.5C7.25 2.59 8.59 1.25 10.5 1.25H13.5C15.41 1.25 16.75 2.59 16.75 4.5V8C16.75 8.41 16.41 8.75 16 8.75Z"
        fill="currentColor"
      />
      <path
        d="M18.16 14.78H5.75C5.34 14.78 5 14.44 5 14.03C5 13.62 5.34 13.28 5.75 13.28H18.16C18.57 13.28 18.91 13.62 18.91 14.03C18.91 14.44 18.57 14.78 18.16 14.78Z"
        fill="currentColor"
      />
      <path
        d="M13.2504 14H10.7504C10.3404 14 10.0004 13.66 10.0004 13.25C10.0004 12.84 10.3404 12.5 10.7504 12.5H13.2504C13.6604 12.5 14.0004 12.84 14.0004 13.25C14.0004 13.66 13.6604 14 13.2504 14Z"
        fill="currentColor"
      />
      <path
        d="M13.25 15.5H10.75C10.34 15.5 10 15.16 10 14.75C10 14.34 10.3404 14 10.7504 14H13.2504C13.6604 14 14 14.34 14 14.75C14 15.16 13.66 15.5 13.25 15.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
const OfficeBagIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={OfficeBagIconSVG}
      style={{
        // color: color || themeDefault?.info?.newConfig?.color,

        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default OfficeBagIcon;
